export default "__VITE_ASSET__f4a33352__"